import { isBrowser } from "@shipt/analytics-core";
import { postWorkerFlushMessage } from "./utils/browser";
const DEFAULT_TIMEOUT = 2000;
/**
 *
 * @param waitTimeout - duration to wait for flush to complete.
 * @param debug - when true, library will log through flush process
 * @returns flushResult  - result of flush.
 * 'flushed' - successful flush
 * 'timeout' - flush did not complete before alloted waitTimeout
 * 'error' - error flushing events
 * 'non-browser' - code executed in a non-browser setting.
 */
export const flush = async (waitTimeout, debug) => {
    let result;
    try {
        if (!isBrowser()) {
            result = "non-browser";
        }
        if (!waitTimeout) {
            console.warn(`No "waitTimeout" provided to flush. Setting default of ${DEFAULT_TIMEOUT}ms`);
            waitTimeout = DEFAULT_TIMEOUT;
        }
        if (debug) {
            console.log("Telling worker to flush events...");
        }
        const isFlushedInTime = await postWorkerFlushMessage(waitTimeout, debug);
        result = isFlushedInTime ? "flushed" : "timeout";
        if (debug) {
            console.log(`Worker is done flushing. Flush result: ${result}`);
        }
        result = isFlushedInTime ? "flushed" : "timeout";
    }
    catch (e) {
        console.error(e);
        result = "error";
    }
    return result;
};
